module.exports = __webpack_public_path__ + "static/img/ghoul3.c60798f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/ghoul3.png
// module id = LwGQ
// module chunks = 0